import { createSearchParams } from "react-router-dom";

import { convertSearchParamsToObject } from "./convertSearchParamsToObject";

export const getLinkToWithNewSearchParameter = ({
  searchParams,
  parameterName,
  parameterValue
}: {
  searchParams: URLSearchParams;
  parameterName: string;
  parameterValue: string | number | boolean;
}) => {
  const existingParams = convertSearchParamsToObject(searchParams);
  const newParams = createSearchParams({
    ...existingParams,
    [parameterName]: String(parameterValue)
  });
  return { search: `?${newParams.toString()}` };
};
